import { visionURL } from "../config/environment";
import Jsona from "jsona";
import JsonApiService from "../services/jsonapiService";
import { useEffect, useState } from "react";
import { mapKeys } from "lodash";

const dataFormatter = new Jsona();

// Filter keys for roles controller
const filterKeys = {
  statusType: "status_type_id_eq",
  assignableByPosition: "assignable_by_position_eq",
  positionId: "position_id"
};

const rolesService = async () =>
  new JsonApiService("roles", {
    baseUrl: `${visionURL}/admin_console/api/administration`,
    credentials: "include"
  });

export const useRoles = (filters = {}) => {
  const [roles, setRoles] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const filterList = mapKeys(filters, (val, key) => filterKeys[key]);

  useEffect(() => {
    const fetchRoles = async () => {
      setIsLoading(true);
      const service = await rolesService();
      const response = await service
        .where(filterList)
        .all()
        .then(response => response.json());
      setIsLoading(false);
      setRoles(dataFormatter.deserialize(response));
    };
    fetchRoles();
  }, []);

  return {
    roles,
    isLoading
  };
};
